import { render, staticRenderFns } from "./HubDetail.vue?vue&type=template&id=eb3b366a&scoped=true"
import script from "./HubDetail.vue?vue&type=script&lang=js"
export * from "./HubDetail.vue?vue&type=script&lang=js"
import style0 from "./HubDetail.vue?vue&type=style&index=0&id=eb3b366a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3b366a",
  null
  
)

export default component.exports